<template>
  <nav
    class="c-mainNavBeforeLogin"
    :class="{ 'c-mainNavBeforeLogin-business': headerType === HEADER_TYPE.BUSINESS_BEFORE_LOGIN }"
  >
    <ul class="c-mainNavBeforeLogin_list">
      <li class="c-mainNavBeforeLogin_item c-mainNavBeforeLogin_item-search">
        <a
          href="javascript:;"
          @click="$emit('click-search')"
        >
          <CoconalaIcon
            name="search"
            size="22px"
          />
        </a>
      </li>
      <li
        v-if="headerType === HEADER_TYPE.BUSINESS_BEFORE_LOGIN"
        class="c-mainNavBeforeLogin_item c-mainNavBeforeLogin_item-manage"
      >
        <a href="/">
          {{ privateAccountInfo.isCurrent ? 'ココナラはこちら' : '出品・プライベート購入の方はこちら' }}
        </a>
      </li>
      <li
        v-else
        class="c-mainNavBeforeLogin_item c-mainNavBeforeLogin_item-manage"
      >
        <NuxtLink
          to="/business/?ref=common_header"
          class="c-mainNavBeforeLogin_businessLink"
        >
          ビジネス購入の方はこちら
        </NuxtLink>
      </li>
      <li class="c-mainNavBeforeLogin_item c-mainNavBeforeLogin_item-help">
        <BalloonDropdown
          position="is-bottom-left"
          @active-change="updateActiveMenu('help', $event)"
          :is-active="isActiveMenu('help')"
          :triggers="[]"
        >
          <a
            href="javascript:;"
            slot="trigger"
            @click="toggleMenu('help')"
          >
            <BTooltip
              label="サポート"
              type="is-black"
              size="is-small"
              position="is-bottom"
              :active="!isActiveMenu('help')"
            >
              <CoconalaIcon
                name="question-circle-o"
                size="22px"
              />
            </BTooltip>
          </a>
          <ClientOnly>
            <MenuHelp
              v-if="isActiveMenu('help')"
              :header-type="headerType"
            />
          </ClientOnly>
        </BalloonDropdown>
      </li>
      <li
        class="c-mainNavBeforeLogin_item"
        v-if="headerType === HEADER_TYPE.BUSINESS_BEFORE_LOGIN"
      >
        <DButton
          :href="$coconala.businessLoginURL($route.fullPath)"
          size="small"
          type="outlined"
          pattern="business"
          is-bold
          rel="nofollow"
        >
          ログイン
        </DButton>
        <DButton
          href="/business/register"
          size="small"
          is-bold
          rel="nofollow"
        >
          会員登録
        </DButton>
      </li>
      <li
        class="c-mainNavBeforeLogin_item"
        v-else
      >
        <DButton
          :href="$coconala.loginURL($route.fullPath)"
          size="small"
          type="outlined"
          is-bold
          rel="nofollow"
        >
          ログイン
        </DButton>
        <DButton
          :href="$coconala.registrationURL($route.fullPath)"
          size="small"
          is-bold
          rel="nofollow"
        >
          会員登録
        </DButton>
      </li>
    </ul>
  </nav>
</template>
<script>
import DButton from '~/components/atoms/DS2/DButton'
import BalloonDropdown from '~/components/molecules/BalloonDropdown'

import { mapState } from 'vuex'

export default {
  name: 'MainNavBeforeLogin',
  components: {
    DButton,
    BalloonDropdown,
    MenuHelp: () => import('./MenuHelp' /* webpackChunkName: "MenuHelp" */)
  },
  props: {
    headerType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentActiveMenu: null
    }
  },
  computed: {
    ...mapState('constants', ['HEADER_TYPE']),
    ...mapState('my/header', ['privateAccountInfo'])
  },
  methods: {
    updateActiveMenu(menuName, isActive) {
      if (isActive) {
        this.currentActiveMenu = menuName
      } else if (this.currentActiveMenu === menuName) {
        this.currentActiveMenu = null
      }
    },
    isActiveMenu(menuName) {
      return this.currentActiveMenu === menuName
    },
    openMenu(menuName) {
      this.currentActiveMenu = menuName
    },
    closeMenu() {
      this.currentActiveMenu = null
    },
    toggleMenu(menuName) {
      if (this.isActiveMenu(menuName)) {
        this.closeMenu()
      } else {
        this.openMenu(menuName)
      }
    },
    touchMenu(menuName, event) {
      // タッチデバイスではmouseenterとclickが連続で発生してしまうため、それらは使わないようここで止める
      event.preventDefault()
      this.toggleMenu(menuName)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-mainNavBeforeLogin {
  margin-left: auto;
  padding-left: 12px;

  a {
    color: $ds2-color-gray-600;

    &:not(.d-button) {
      @include link-effect-background;
    }
  }

  .d-button {
    width: 84px;
    white-space: nowrap;

    & + .d-button {
      margin-left: 8px;
    }
  }

  &-business {
    a {
      color: $ds2-color-gray-25;

      &:not(.d-button) {
        @include link-effect-background-business;
      }
    }
  }

  &_list {
    display: flex;
  }

  &_item {
    display: flex;

    align-items: center;

    &-search {
      display: none;
    }

    &-manage {
      margin-right: 4px;
      font-weight: bold;
      font-size: 13px;
    }

    &-help {
      margin: 0 12px 1px 0;

      .coconala-icon {
        &::before {
          vertical-align: -2px;
        }
      }
    }

    /deep/ .dropdown {
      &-content {
        padding: 24px 0;
      }

      &-item {
        padding: 0 16px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
      }
    }
  }

  &_businessLink {
    color: $ds2-color-brand-secondary !important;
    font-size: 13px;
  }

  .c-balloonDropdown {
    a {
      display: flex;

      align-items: center;
    }
  }
}

@media (max-width: breakpoint(Header, M)) {
  .c-mainNavBeforeLogin {
    .c-mainNavBeforeLogin {
      &_item {
        &-manage {
          display: none;
        }
      }
    }

    &-business {
      .c-mainNavBeforeLogin {
        &_item {
          &-manage {
            display: none;
          }

          &-help {
            display: none;
          }
        }
      }
    }
  }
}

@media (max-width: breakpoint(Header, S)) {
  .c-mainNavBeforeLogin {
    padding-left: 0;

    &_item {
      &-search {
        display: flex;
        margin-right: 4px;

        .coconala-icon {
          &::before {
            vertical-align: -1px;
          }
        }
      }

      &-help {
        display: none;
      }
    }

    .d-button {
      padding: 0 !important;
      width: 74px;

      & + .d-button {
        margin-left: 8px;
      }
    }
  }
}

@media (max-width: 374px) {
  .c-mainNavBeforeLogin {
    .d-button {
      width: 64px;
    }
  }
}

// NOTE: IE hack
*::-ms-backdrop,
.c-mainNavBeforeLogin {
  position: absolute;
  top: 14px;
  right: 24px;
}
</style>
